import {FormField} from "../form-field/form-field";

export class FormFieldFiles extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$dropZone = null;
        this.$input = null;
    }

    getVal(){
        return this.$input.val();
    }

    setVal(val,noEvent){
        this.$dropZone.dropzoneSetValue(val);
        this.$input.val(val);
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

	ready(){
        super.ready();
        this.$dropZone = this.findMember("files");
        this.$input = this.findMember("input");
    }
}

